import React, { ChangeEvent, useRef, useState } from 'react'
import cx from 'classnames'
import { Progress } from 'reactstrap'
import Button from 'components/Button'
import ModalDialog, { ModalDialogProps } from 'components/ModalDialog'
import { MediaType } from 'constants/media'
import { IMedia } from 'interfaces/media'
import MediaCard from './components/MediaItem'
import styles from './mediaManager.module.scss'

interface MediaManagerProps extends Omit<ModalDialogProps, 'title'> {
  mediaList: (IMedia & { collectionId?: number })[] // INFO: currently using to display main image from collection as well
  onFileUpload?: (fileUpload: File, setUploadProgress: (percent: number) => any) => any
  onUpdateCaption?: (mediaId: number, caption: string) => any
  noEditCaption?: boolean
  handleShowAutosave?: () => void
  accept?: string
}

export enum MediaFileType {
  IMAGE = 'image',
  VIDEO = 'video',
  FILE = 'other'
}

export const MEDIATYPES: { [key: string]: any } = {
  image: {
    mediaType: MediaType.IMAGE,
    column: 'image'
  },
  video: {
    mediaType: MediaType.VIDEO,
    column: 'video'
  },
  other: {
    mediaType: MediaType.FILE,
    column: 'document'
  }
}

const MediaManager = ({
  mediaList,
  onFileUpload = () => {},
  onUpdateCaption = () => {},
  handleShowAutosave = () => {},
  noEditCaption = false,
  className,
  accept = '',
  ...props
}: MediaManagerProps) => {
  const fileInputRef = useRef<any>(null)
  const [uploadProgress, setUploadProgress] = useState(0)
  const [uploadingFileName, setUploadingFileName] = useState('')

  // async function handleUpload(evt: ChangeEvent<HTMLInputElement>) {
  //   if (evt.currentTarget.files) {
  //     const fileToUpload = evt.currentTarget.files[0]
  //     if (fileToUpload) {
  //       setUploadingFileName(fileToUpload.name)

  //       try {
  //         await Promise.resolve(onFileUpload(fileToUpload, setUploadProgress))
  //         await handleShowAutosave()
  //       } finally {
  //         setUploadingFileName('')
  //       }
  //     }
  //   }
  // }
  async function handleUpload(evt: ChangeEvent<HTMLInputElement>) {
    if (evt.currentTarget.files) {
      const fileToUpload = evt.currentTarget.files[0]
      if (fileToUpload) {
        setUploadingFileName(fileToUpload.name)

        try {
          await Promise.resolve(onFileUpload(fileToUpload, setUploadProgress))
          await handleShowAutosave()
        } finally {
          setUploadingFileName('')
        }
      }
    }
  }

  return (
    <ModalDialog title="MANAGE MEDIA" className={cx(styles.dialog, className)} {...props}>
      <div className={styles.uploadPanel}>
        {uploadingFileName ? (
          <>
            <span>Uploading: {uploadingFileName}</span>
            <Progress value={uploadProgress} color="info">
              {uploadProgress}%
            </Progress>
          </>
        ) : (
          <>
            <input type="file" accept={accept} ref={fileInputRef} onChange={handleUpload} style={{ display: 'none' }} />
            <Button outline color="info" onClick={() => fileInputRef.current?.click()}>
              + Upload Media
            </Button>
          </>
        )}
      </div>
      <div>
        {mediaList.map(media => (
          <MediaCard
            media={media}
            key={media.id}
            noEditCaption={noEditCaption}
            onChangeCaption={(caption: string) => onUpdateCaption(media.id, caption)}
          />
        ))}
      </div>
    </ModalDialog>
  )
}

export default MediaManager
